import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useNamespacedTranslation } from '../../../../../../../hooks/useNamespacedTranslation';

type Props = {
  className?: string;
  showTimeEntryLabel: boolean;
  i18prefix: string;
};

const DayTimeInputLabels: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  showTimeEntryLabel,
  i18prefix,
}) => {
  const t = useNamespacedTranslation(i18prefix);

  return (
    <Row className={className}>
      {showTimeEntryLabel && (
        <Col lg={2} xs={3}>
          <Form.Label className="mb-0">
            {t('timeEntries.form.timeEntryLabel')}
          </Form.Label>
        </Col>
      )}
      <Col lg={showTimeEntryLabel ? 6 : 8} xs={showTimeEntryLabel ? 4 : 7}>
        <Form.Label className="mb-0">
          {t('timeEntries.form.projectsLabel')}
        </Form.Label>
      </Col>
      <Col lg={3} xs={4}>
        <Form.Label className="mb-0">
          {t('timeEntries.form.hoursLabel')}
        </Form.Label>
      </Col>
    </Row>
  );
};

export default DayTimeInputLabels;
